export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Final2_08.3c5d512d.jpg";